<template>
    <div>
        <div class="level">
            <div class="level-left">
                <router-link :to="{name: 'Create Newsfeed'}" class="button is-small is-info">
                    <span class="icon">
                        <i class="fas fa-plus"></i>
                    </span>&nbsp; Create new</router-link>
                &nbsp;
                <button class="button is-small" @click="refreshTable()">Refresh</button>
            </div>
            <div class="level-right">
                <b-select size="is-small" v-model="perPage">
                    <option value="5">5 per page</option>
                    <option value="10">10 per page</option>
                    <option value="15">15 per page</option>
                    <option value="20">20 per page</option>
                    <option value="100">100 per page</option>
                    <option value="200">200 per page</option>
                    <option value="300">300 per page</option>
                    <option value="1000">1000 per page</option>
                </b-select>
            </div>
        </div>
        <table-pagination :tableData="newsfeeds.data" :bordered="true" :striped="true" :narrowed="true" :hoverable="true" :mobileCards="true" :loading="isLoadingTable" :page="page" :perPage="perPage" :totalData="newsfeeds.totalData" @onPageChanged="page = $event" @onSearchChanged="search = $event" @onPerPageChanged="perPage = $event">
            <template slot="row-content" slot-scope="{item}">
                <b-table-column field="newsfeedId" class="table-column-content-is-small" label="ID">
                    {{item.row.newsfeedId}}
                </b-table-column>
                <b-table-column field="newsfeedId" class="table-column-content-is-small" label="Title">
                    {{item.row.name}}
                </b-table-column>
                <b-table-column field="newsfeedId" class="table-column-content-is-small" label="Desc.">
                    {{item.row.desc}}
                </b-table-column>
                <b-table-column field="newsfeedId" class="table-column-content-is-small" label="Blog date">
                    {{item.row.date}}
                </b-table-column>
                <b-table-column field="newsfeedId" class="table-column-content-is-small" label="Date created">
                    {{item.row.dateCreated}}
                </b-table-column>
                <b-table-column field="" class="table-column-content-is-small" label="">
                    <router-link :to="{name: 'Edit Newsfeed', params: {'newsfeedId': item.row.newsfeedId}}" class="button is-warning is-small">Edit</router-link>
                    &nbsp;
                    <button class="button is-danger is-small" @click="deleteNewsfeed(item.row.newsfeedId)">Delete</button>
                </b-table-column>
            </template>
            <template slot="empty">
                <section class="section">
                    <div class="content has-text-grey has-text-centered">
                        <p>
                            <b-icon icon="emoticon-sad" size="is-large">
                            </b-icon>
                        </p>
                        <p>Nothing here.</p>
                    </div>
                </section>
            </template>
        </table-pagination>
        <delete-modal/>
    </div>
</template>

<script>
import TablePagination from '../TablePagination.vue'
import { mapState, mapActions } from 'vuex'
import DeleteModal from './Delete.vue'
import AppToast from '../frontend/appToast'
import AppButton from '../frontend/appButton'
import axios from 'axios'

const appToast = new AppToast()
const appButton = new AppButton()

export default {
  data: () => ({
    isEmpty: false,
    page: 1,
    perPage: 10,
    search: ''
  }),
  computed: {
    ...mapState('newsfeed', {
      isLoadingTable: state => state.isLoadingTable,
      newsfeeds: state => state.newsfeeds,
      showDeleteModal: state => state.showDeleteModal
    })
  },
  components: {
    tablePagination: TablePagination,
    deleteModal: DeleteModal
  },
  mounted() {
    this.default()
  },
  methods: {
    ...mapActions('newsfeed', ['getPaginatedNewsfeeds', 'openDeleteModal']),
    default() {
      this.getPaginatedNewsfeeds({
        page: this.page,
        pageSize: this.perPage,
        query: this.search
      })
    },
    refreshTable() {
      this.default()
    },
    deleteNewsfeed(newsfeedId) {
      this.openDeleteModal({
        showDeleteModal: true,
        newsfeed: {
          newsfeedId: newsfeedId
        }
      })
    }
  },
  watch: {
    perPage(val) {
      this.getPaginatedNewsfeeds({
        page: this.page,
        pageSize: val,
        query: this.search
      })
    },
    page(val) {
      this.getPaginatedNewsfeeds({
        page: val,
        pageSize: this.perPage,
        query: this.search
      })
    },
    search(val) {
      this.getPaginatedNewsfeeds({
        page: this.page,
        pageSize: this.perPage,
        query: val
      })
    },
    showDeleteModal() {
      this.default()
    }
  }
}
</script>

